import React, { useRef, useState, useLayoutEffect } from 'react';
import './Collapsible.css';

/**
 * Collapsible - glatka expand/collapse animacija koja radi na svim uređajima.
 *
 * Koristi `height` tranziciju sa izmerenom visinom sadržaja (preko ResizeObserver),
 * umesto `grid-template-rows: 0fr -> 1fr` koja nije glatko podržana na iOS Safari
 * i mobilnim uređajima.
 */
const Collapsible = ({ open, children, className = '' }) => {
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const updateHeight = () => {
      setContentHeight(el.scrollHeight);
    };

    updateHeight();

    // Prati promene veličine sadržaja (npr. kada se lista zadataka osveži)
    let observer;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(updateHeight);
      observer.observe(el);
    }

    return () => {
      if (observer) observer.disconnect();
    };
    // Ponovo izmeri i kada se `open` promeni - sadržaj ugnježdenog Collapsible-a
    // je dok je roditelj zatvoren visine 0, pa bi bez ovoga ostao "sklopljen".
  }, [open]);

  return (
    <div
      className={`collapsible ${open ? 'collapsible--open' : ''} ${className}`}
      style={{ height: open ? contentHeight : 0 }}
      aria-hidden={!open}
    >
      <div ref={contentRef} className="collapsible__inner">
        {children}
      </div>
    </div>
  );
};

export default Collapsible;
